// Fonds de carte gratuits et SANS clé API (CARTO exige désormais une clé :
// ses tuiles affichaient « API KEY REQUIRED »).
//  - IGN Géoplateforme (data.geopf.fr) : Plan IGN et photos aériennes, service
//    public gratuit, idéal pour la France ;
//  - OpenStreetMap : de secours si l'IGN ne répond pas.
// Le mode « Sombre » est le Plan IGN assombri par un filtre CSS (classe
// tiles-dark, voir index.css) : aucun fournisseur payant nécessaire.
const IGN_WMTS =
  "https://data.geopf.fr/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&STYLE=normal&TILEMATRIXSET=PM" +
  "&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}";
const IGN_ATTR = '&copy; <a href="https://www.ign.fr/">IGN</a> – <a href="https://geoservices.ign.fr/">Géoplateforme</a>';
const OSM_ATTR = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>';

export const TILE_LAYERS = {
  plan: {
    label: "Plan",
    url: `${IGN_WMTS}&LAYER=GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2&FORMAT=image/png`,
    attribution: IGN_ATTR,
    maxNativeZoom: 19,
    maxZoom: 20,
    fallback: "osm",
  },
  sombre: {
    label: "Sombre",
    url: `${IGN_WMTS}&LAYER=GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2&FORMAT=image/png`,
    attribution: IGN_ATTR,
    maxNativeZoom: 19,
    maxZoom: 20,
    className: "tiles-dark",
    fallback: "osm",
  },
  osm: {
    label: "OSM",
    url: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution: OSM_ATTR,
    maxNativeZoom: 19,
    maxZoom: 20,
  },
  satellite: {
    label: "Satellite",
    url: `${IGN_WMTS}&LAYER=ORTHOIMAGERY.ORTHOPHOTOS&FORMAT=image/jpeg`,
    attribution: IGN_ATTR,
    maxNativeZoom: 19,
    maxZoom: 20,
    fallback: "osm",
  },
};

const GROUP_PALETTE = ["#e8a33d", "#3fa7d6", "#59cd90", "#ee6352", "#a97ccf", "#f2c14e", "#4ecdc4", "#ff8fab", "#9bc53d", "#5b8def"];

function hash(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) | 0;
  return Math.abs(h);
}

export function groupColor(name, list) {
  if (!name) return "#9ca3af";
  if (list) {
    const i = list.indexOf(name);
    if (i >= 0) return GROUP_PALETTE[i % GROUP_PALETTE.length];
  }
  return GROUP_PALETTE[hash(name.toLowerCase()) % GROUP_PALETTE.length];
}

export const MULTI_COLOR = "#9ca3af";
export const NONE_COLOR = "#6b7280";

/** Couleur d'une tournée selon le mode de coloration choisi. */
export function tourneeColor(code, ctx) {
  const t = ctx.tourneesByCode[code];
  if (!t) return MULTI_COLOR;
  if (ctx.colorBy === "secteur") return groupColor(t.secteur, ctx.secteurs);
  if (ctx.colorBy === "sst") return groupColor(t.sst, ctx.ssts);
  return t.couleur || "#3388ff";
}

export function zoneColor(zone, ctx) {
  if (ctx.colorBy === "tournee") return zone.couleur;
  const t = ctx.tourneesByCode[zone.tournee];
  if (ctx.colorBy === "secteur") return groupColor(t?.secteur || zone.secteur, ctx.secteurs);
  return groupColor(zone.sst || t?.sst, ctx.ssts);
}

/** Texte lisible (noir ou blanc) sur une couleur de fond. */
export function textOn(hex) {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex || "");
  if (!m) return "#fff";
  const n = parseInt(m[1], 16);
  const r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.6 ? "#111" : "#fff";
}

export const PIN_SVG = `<svg width="34" height="46" viewBox="0 0 34 46" xmlns="http://www.w3.org/2000/svg">
<path d="M17 1C8.2 1 1 7.9 1 16.6 1 28.3 17 45 17 45s16-16.7 16-28.4C33 7.9 25.8 1 17 1z" fill="#ea4335" stroke="#a52714" stroke-width="1.5"/>
<circle cx="17" cy="16.5" r="6" fill="#7b1c10"/></svg>`;
